import { NgModule } from '@angular/core';

import { DeletePostActions } from './delete-post.component';
import {SharedModule} from '../../../shared.module';




@NgModule({
  imports:[
	SharedModule
  ],
  declarations: [
  	DeletePostActions,
    
  ],
  entryComponents:[
    DeletePostActions
  ]
})
export class DeletePostModule { }
